import { MenuItem as MuiMenuItem } from '@mui/material';
import Divider from '@mui/material/Divider';
import { listBoxGroupHeaderStyleBuilder, listBoxItemStyleBuilder } from './listBoxStyleBuilder';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { ListBoxItemContent } from './ListBoxItemContent';
import { ListGroupHeader } from './ListGroupHeader';
import { nanoid } from 'nanoid';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const ListBoxItem = _ref => {
  let {
    divider,
    disabled,
    label,
    selected,
    onClick,
    onMouseClick,
    component,
    className,
    onKeyDown,
    autoFocus,
    sx,
    id,
    size = 'small',
    groupHeader,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const itemStyle = mergeSxStyle(groupHeader ? listBoxGroupHeaderStyleBuilder(theme, size) : listBoxItemStyleBuilder(theme, size), sx);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MuiMenuItem, {
      disabled: disabled,
      selected: selected,
      onClick: onClick,
      onMouseDown: onMouseClick,
      className: className,
      autoFocus: autoFocus,
      onKeyDown: onKeyDown,
      sx: itemStyle,
      disableRipple: true,
      disableTouchRipple: true,
      id: id,
      "data-testid": rest['data-testid'],
      children: groupHeader ? /*#__PURE__*/_jsx(ListGroupHeader, {
        className: `ids-list-box-group-header`,
        theme: theme,
        children: label
      }, nanoid()) : /*#__PURE__*/_jsx(ListBoxItemContent, {
        className: `ids-list-box-item`,
        content: label,
        size: size,
        selected: Boolean(selected)
      })
    }), divider && /*#__PURE__*/_jsx(Divider, {})]
  });
};